import { Divider, Grid } from '@mui/material';
import ProductInfoItem from '../ProductInfoItem/ProductInfoItem';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { UpdateProductInfoFormValues } from 'pages/product/CreateProductPage/updateProductInfoValidationSchema';

export default function ProductDescriptionFormDetails() {
  const { getValues } = useFormContext<UpdateProductInfoFormValues>();
  const values = getValues();

  const fields = [
    {
      label: 'English Description',
      value: values.translations.en.description,
      show: !!values.translations?.en?.description,
    },
    {
      label: 'Arabic Description',
      value: values.translations.ar.description,
      show: !!values.translations?.ar?.description,
    },
  ].filter((field) => field.show);

  return (
    <>
      {fields.map((field, index) => (
        <React.Fragment key={field.label}>
          <Grid size={{ xs: 12, md: 6 }}>
            <ProductInfoItem label={field.label} value={field.value} />
          </Grid>

          {index % 2 === 1 && index < fields.length - 1 && (
            <Grid size={12}>
              <Divider />
            </Grid>
          )}
        </React.Fragment>
      ))}
    </>
  );
}
